export default {
    "layoutParams": {
        "groups": {
            "density": "layoutParams_groups_density",
            "groupByOrientation": "layoutParams_groups_groupByOrientation",
            "numberOfGroupsPerRow": "layoutParams_groups_numberOfGroupsPerRow",
            "allowedGroupTypes": "layoutParams_groups_allowedGroupTypes",
            "repeatingGroupTypes": "layoutParams_groups_repeatingGroupTypes",
            "groupSize": "layoutParams_groups_groupSize"
        },
        "crop": {
            "method": "layoutParams_crop_method",
            "alignment": "layoutParams_crop_alignment",
            "enable": "layoutParams_crop_enable",
            "enableSmartCrop": "layoutParams_crop_enableSmartCrop",
            "cropOnlyFill": "layoutParams_crop_cropOnlyFill",
            "ratios": "layoutParams_crop_ratios"
        },
        "structure": {
            "galleryLayout": "layoutParams_structure_galleryLayout",
            "galleryRatio": {
                "value": "layoutParams_structure_galleryRatio_value",
                "includeExternalInfo": "layoutParams_structure_galleryRatio_includeExternalInfo"
            },
            "enableStreching": "layoutParams_structure_enableStreching",
            "gallerySpacing": "layoutParams_structure_gallerySpacing",
            "itemSpacing": "layoutParams_structure_itemSpacing",
            "scrollDirection": "layoutParams_structure_scrollDirection",
            "numberOfColumns": "layoutParams_structure_numberOfColumns",
            "numberOfGridRows": "layoutParams_structure_numberOfGridRows",
            "responsiveMode": "layoutParams_structure_responsiveMode",
            "columnRatios": "layoutParams_structure_columnRatios",
            "scatter": {
                "randomScatter": "layoutParams_structure_scatter_randomScatter",
                "manualScatter": "layoutParams_structure_scatter_manualScatter"
            },
            "layoutOrientation": "layoutParams_structure_layoutOrientation",
            "groupsOrder": "layoutParams_structure_groupsOrder"
        },
        "thumbnails": {
            "enable": "layoutParams_thumbnails_enable",
            "position": "layoutParams_thumbnails_position",
            "spacing": "layoutParams_thumbnails_spacing",
            "size": "layoutParams_thumbnails_size",
            "alignment": "layoutParams_thumbnails_alignment"
        },
        "navigationArrows": {
            "enable": "layoutParams_navigationArrows_enable",
            "size": "layoutParams_navigationArrows_size",
            "padding": "layoutParams_navigationArrows_padding",
            "position": "layoutParams_navigationArrows_position",
            "verticalAlignment": "layoutParams_navigationArrows_verticalAlignment",
            "type": "layoutParams_navigationArrows_type",
            "container": {
                "type": "layoutParams_navigationArrows_container_type",
                "borderRadius": "layoutParams_navigationArrows_container_borderRadius",
                "backgroundColor": "layoutParams_navigationArrows_container_backgroundColor"
            },
            "mouseCursorContainerMaxWidth": "layoutParams_navigationArrows_mouseCursorContainerMaxWidth"
        },
        "info": {
            "sizeUnits": "layoutParams_info_sizeUnits",
            "width": "layoutParams_info_width",
            "height": "layoutParams_info_height",
            "spacing": "layoutParams_info_spacing",
            "layout": "layoutParams_info_layout",
            "border": {
                "width": "layoutParams_info_border_width",
                "color": "layoutParams_info_border_color",
                "radius": "layoutParams_info_border_radius"
            },
            "placement": "layoutParams_info_placement"
        },
        "targetItemSize": {
            "unit": "layoutParams_targetItemSize_unit",
            "value": "layoutParams_targetItemSize_value",
            "minimum": "layoutParams_targetItemSize_minimum"
        }
    },
    "behaviourParams": {
        "item": {
            "clickAction": "behaviourParams_item_clickAction",
            "video": {
                "speed": "behaviourParams_item_video_speed",
                "volume": "behaviourParams_item_video_volume",
                "loop": "behaviourParams_item_video_loop",
                "playTrigger": "behaviourParams_item_video_playTrigger",
                "enablePlayButton": "behaviourParams_item_video_enablePlayButton",
                "enableControls": "behaviourParams_item_video_enableControls",
                "enablePlaceholder": "behaviourParams_item_video_enablePlaceholder"
            },
            "overlay": {
                "hoveringBehaviour": "behaviourParams_item_overlay_hoveringBehaviour",
                "hoverAnimation": "behaviourParams_item_overlay_hoverAnimation",
                "position": "behaviourParams_item_overlay_position",
                "size": "behaviourParams_item_overlay_size",
                "sizeUnits": "behaviourParams_item_overlay_sizeUnits",
                "padding": "behaviourParams_item_overlay_padding"
            },
            "content": {
                "hoverAnimation": "behaviourParams_item_content_hoverAnimation",
                "placementAnimation": "behaviourParams_item_content_placementAnimation",
                "loader": "behaviourParams_item_content_loader",
                "magnificationValue": "behaviourParams_item_content_magnificationValue"
            },
            "secondaryMedia": {
                "trigger": "behaviourParams_item_secondaryMedia_trigger",
                "behaviour": "behaviourParams_item_secondaryMedia_behaviour"
            }
        },
        "gallery": {
            "layoutDirection": "behaviourParams_gallery_layoutDirection",
            "blockContextMenu": "behaviourParams_gallery_blockContextMenu",
            "scrollAnimation": "behaviourParams_gallery_scrollAnimation",
            "enableIndexingShareLinks": "behaviourParams_gallery_enableIndexingShareLinks",
            "vertical": {
                "loadMore": {
                    "enable": "behaviourParams_gallery_vertical_loadMore_enable",
                    "amount": "behaviourParams_gallery_vertical_loadMore_amount",
                    "text": "behaviourParams_gallery_vertical_loadMore_text"
                }
            },
            "horizontal": {
                "enableScrollSnap": "behaviourParams_gallery_horizontal_enableScrollSnap",
                "slideAnimation": "behaviourParams_gallery_horizontal_slideAnimation",
                "slideTransition": "behaviourParams_gallery_horizontal_slideTransition",
                "blockScroll": "behaviourParams_gallery_horizontal_blockScroll",
                "navigationDuration": "behaviourParams_gallery_horizontal_navigationDuration",
                "loop": "behaviourParams_gallery_horizontal_loop",
                "autoSlide": {
                    "behaviour": "behaviourParams_gallery_horizontal_autoSlide_behaviour",
                    "interval": "behaviourParams_gallery_horizontal_autoSlide_interval",
                    "pauseOnHover": "behaviourParams_gallery_horizontal_autoSlide_pauseOnHover",
                    "speed": "behaviourParams_gallery_horizontal_autoSlide_speed"
                },
                "slideshowInfo": {
                    "buttonsAlignment": "behaviourParams_gallery_horizontal_slideshowInfo_buttonsAlignment",
                    "enableCounter": "behaviourParams_gallery_horizontal_slideshowInfo_enableCounter",
                    "enablePlayButton": "behaviourParams_gallery_horizontal_slideshowInfo_enablePlayButton"
                }
            }
        }
    },
    "stylingParams": {
        "arrowsColor": "stylingParams_arrowsColor",
        "itemShadowBlur": "stylingParams_itemShadowBlur",
        "itemShadowDirection": "stylingParams_itemShadowDirection",
        "itemShadowOpacityAndColor": "stylingParams_itemShadowOpacityAndColor",
        "itemShadowSize": "stylingParams_itemShadowSize",
        "itemEnableShadow": "stylingParams_itemEnableShadow",
        "itemBorderRadius": "stylingParams_itemBorderRadius",
        "itemBorderWidth": "stylingParams_itemBorderWidth",
        "itemResolutionMode": "stylingParams_itemResolutionMode"
    }
};
//# sourceMappingURL=optionsMap.js.map